import { ConfigProvider } from 'antd';
import LayoutComp from './Layout';
import './App.scss';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2a61eb',
          fontFamily: 'Poppins, system-ui, sans-serif',
          borderRadius: 10,
        },
      }}
    >
      <div className="App">
        <LayoutComp />
      </div>
    </ConfigProvider>
  );
}

export default App;
